module.exports = __webpack_public_path__ + "static/media/icon_circle_warning.a5bd75af.svg";